// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OrderActionEnum;
(function (OrderActionEnum) {
    OrderActionEnum[OrderActionEnum["Unspecified"] = 0] = "Unspecified";
    OrderActionEnum[OrderActionEnum["All"] = 1] = "All";
    OrderActionEnum[OrderActionEnum["Buy"] = 2] = "Buy";
    OrderActionEnum[OrderActionEnum["Sell"] = 3] = "Sell";
    OrderActionEnum[OrderActionEnum["Days"] = 4] = "Days";
    OrderActionEnum[OrderActionEnum["GTCs"] = 5] = "GTCs";
    OrderActionEnum[OrderActionEnum["Stops"] = 6] = "Stops";
    OrderActionEnum[OrderActionEnum["Limits"] = 7] = "Limits";
    OrderActionEnum[OrderActionEnum["ByIds"] = 8] = "ByIds";
    OrderActionEnum[OrderActionEnum["ByInstrument"] = 9] = "ByInstrument";
    OrderActionEnum[OrderActionEnum["ChangeToMarket"] = 10] = "ChangeToMarket";
    OrderActionEnum[OrderActionEnum["ByAccount"] = 11] = "ByAccount";
    OrderActionEnum[OrderActionEnum["ByAccountAndInstrument"] = 12] = "ByAccountAndInstrument";
    OrderActionEnum[OrderActionEnum["ModifyOrder"] = 13] = "ModifyOrder";
    OrderActionEnum[OrderActionEnum["LinkAsOCO"] = 14] = "LinkAsOCO";
    OrderActionEnum[OrderActionEnum["UnLinkAsOCO"] = 15] = "UnLinkAsOCO";
    OrderActionEnum[OrderActionEnum["ShowToolbar"] = 16] = "ShowToolbar";
})(OrderActionEnum || (OrderActionEnum = {}));
